import { render, staticRenderFns } from "./source_download_page.vue?vue&type=template&id=7bb14918"
import script from "./source_download_page.vue?vue&type=script&setup=true&lang=js"
export * from "./source_download_page.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports